<template>
	<section class="container">
		<div class="lay">
			<popup @close="$router.back()">
				<div class="frame">
					<div class="frame-label">Сброс пароля</div>
					<form action="" class="form" @submit.prevent="submit">
						<div class="form-control">
							<label class="form-label">Электронная почта</label>
							<input v-model="login" class="form-input" type="text" name="email" />
							<label class="error" v-if="isValid && !idn">Не верный формат электронной почты</label>
						</div>
						<div class="form-control text-center">
							<div class="form-buttons">
								<div class="form-buttonsItem">
									<div class="button" @click="submit"><span>Восстановить пароль</span></div>
								</div>
							</div>
						</div>
					</form>
				</div>
			</popup>
		</div>
	</section>
</template>

<script>
export default {
	data() {
		return {
			login: '',
			password: '',
			isValid: false,
		};
	},
	async fetch({ store, route }) {
		return await store.dispatch('init', { route });
	},
	computed: {
		idn() {
			var re = /^[-\w.]+@([А-яёA-z0-9][-А-яёA-z0-9]+\.)+[А-яёA-z]{2,6}$/;
			return re.test(this.login);
		},
	},
	methods: {
		submit() {
			this.isValid = true;
			if (this.idn)
				this.$store
					.dispatch('api/send', {
						task: 'reset',
						data: {
							login: this.login,
						},
					})
					.then(() => {
						this.$router.push('/profile/login');
					});
		},
	},
};
</script>
